/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x2200b6 from'./../../message.js';class ConnectMessage extends _0x2200b6{constructor(_0x131951){super(),this['documentId']=_0x131951;}['toJSON'](){return{'documentId':this['documentId']};}static['fromJSON'](_0x42dcbc){return new ConnectMessage(_0x42dcbc['documentId']);}}ConnectMessage['TYPE']='92',ConnectMessage['READABLE_TYPE_NAME']='connectToComment',ConnectMessage['DESCRIPTOR_NAME']='CommentsV2ConnectMessage',ConnectMessage['DESCRIPTOR']={'fields':{'documentId':{'type':'string','id':0x1}}};export default ConnectMessage;